/* eslint-disable no-else-return */
/* eslint-disable prefer-const */
/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, TextField, Autocomplete, Button, Checkbox, Divider, FormHelperText, Tooltip, Stack, IconButton, Alert, Paper, FormControlLabel } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { alpha,styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import HeaderCommon from './ApprovalHierarchyHeaderCommon';
import MasterServices from './ApprovalHierarchyMasterServices';
import Iconify from '../../../components/iconify/Iconify';
import DeletePopup from './ApprovalHierarchyDeletePopUp';
import ApprovalHierarchyPopUpHandle from './ApprovalHierarchyPopUpHandle';
import { useAppStore } from '../../../store/appStore';
import { getMenuPermissionsForPath, useMenuAccessStore } from '../../../store/menuAccessStore';
import { useModulePathname, useModuleListPath, useModuleNavigate } from '../../../layouts/main/ModuleNavigation';

const BUDGET_DEPENDENT_FIELDS = ['BudgetCalculationType', 'BudgetLimitMinValue', 'BudgetLimitMaxValue'];
const ADJUSTMENT_DEPENDENT_FIELDS = ['AdjustmentAmountCalculation', 'AdjustmentLimitMinValue', 'AdjustmentLimitMaxValue'];
const BUDGET_MISSING_MAX_CONFIRM_MSG = 'Budget Limit Max Value not entered. This step will be set as the last step. Do you want to proceed?';
const ADJUSTMENT_MISSING_MAX_CONFIRM_MSG = 'Adjustment Limit Max Value not entered. This step will be set as the last step. Do you want to proceed?';
const CONTROL_DISPLAY_ORDER = [
    'BudgetCalculationType',
    'BudgetLimitMinValue',
    'BudgetLimitMaxValue',
    'AdjustmentAmountCalculation',
    'AdjustmentLimitMinValue',
    'AdjustmentLimitMaxValue',
];

const getOrderedControls = (controls = []) => {
    const orderMap = new Map(CONTROL_DISPLAY_ORDER.map((displayExpr, index) => [displayExpr, index]));

    return controls
        .map((control, index) => ({ control, index }))
        .sort((first, second) => {
            const firstIsOrderedControl = orderMap.has(first.control?.DisplayExpr);
            const secondIsOrderedControl = orderMap.has(second.control?.DisplayExpr);

            if (firstIsOrderedControl && secondIsOrderedControl) {
                return orderMap.get(first.control.DisplayExpr) - orderMap.get(second.control.DisplayExpr);
            }

            if (firstIsOrderedControl !== secondIsOrderedControl) {
                return firstIsOrderedControl ? 1 : -1;
            }

            return first.index - second.index;
        })
        .map(({ control }) => control);
};

// Build validation schema
const buildValidationSchema = (entityData) => {
    const schemaFields = {};

    entityData.forEach((field) => { // NOSONAR
        let schema;
        const isBudgetDependentField = BUDGET_DEPENDENT_FIELDS.includes(field.DisplayExpr);
        const isAdjustmentDependentField = ADJUSTMENT_DEPENDENT_FIELDS.includes(field.DisplayExpr);

        switch (field.DataType) {
            case 'Textbox':
                schema = yup.string();
                break;
            case 'Dropdown':
                schema = field.multiple ? yup.array() : yup.mixed();
                break;
            case 'MultiselectDropdown':
                schema = yup.array();
                break;
            default:
                schema = yup.mixed();
        }

        if (field.Validations) {
            field.Validations.forEach((validation) => {
                if (validation.ValidationType === 'Required') {
                    if (isBudgetDependentField) {
                        if (field.DisplayExpr === 'BudgetLimitMinValue' || field.DisplayExpr === 'BudgetLimitMaxValue') {
                            schema = schema.notRequired().nullable();
                        } else {
                            schema = schema.when('SetBudgetApprovalLimit', {
                                is: (value) => value === true || value === 'true',
                                then: (currentSchema) => currentSchema.required(validation.ValidationMessage),
                                otherwise: (currentSchema) => currentSchema.notRequired().nullable(),
                            });
                        }
                    } else if (isAdjustmentDependentField) {
                        if (field.DisplayExpr === 'AdjustmentLimitMinValue' || field.DisplayExpr === 'AdjustmentLimitMaxValue') {
                            schema = schema.notRequired().nullable();
                        } else {
                            schema = schema.when('SetAdjustmentApprovalLimit', {
                                is: (value) => value === true || value === 'true',
                                then: (currentSchema) => currentSchema.required(validation.ValidationMessage),
                                otherwise: (currentSchema) => currentSchema.notRequired().nullable(),
                            });
                        }
                    } else {
                        schema = schema.required(validation.ValidationMessage);
                    }
                }
                // Add more validation types as needed
            });
        }

        schemaFields[field.DisplayExpr] = schema;
    });

    return yup.object().shape(schemaFields);
};

const custom = ({ field, selectedValues, searchedValue, setSelectedValues, setRequiredeHoverValue, controllerField, setControllFieldValue, ...paperProps }) => { // NOSONAR
    const { children, ...restPaperProps } = paperProps;
    const filteredOptions = field.DefaultValues?.filter(item =>
        item[field.DisplayExpr].toLowerCase().includes(searchedValue.toLowerCase())
    );
    const isAllFilteredSelected = filteredOptions?.every(option =>
        selectedValues.some(selected => selected[field.ValueExpr] === option[field.ValueExpr])
    );
    const isAllSelected = selectedValues.length > 0 && selectedValues.length === field.DefaultValues.length;
    
    return (<Paper {...restPaperProps}>
        <Box onMouseDown={(e) => e.preventDefault()} sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}>
            <FormControlLabel
                sx={{ fontSize: '13px' }}
                onClick={(e) => {
                    e.preventDefault();
                    let newSelectedValues;

                    if (searchedValue?.length > 0) {
                        // Handle filtered selection
                        if (isAllFilteredSelected) {
                            // Unselect filtered options
                            newSelectedValues = selectedValues.filter(item =>
                                !filteredOptions.some(filtered => filtered[field.ValueExpr] === item[field.ValueExpr])
                            );
                        } else {
                            // Select filtered options
                            newSelectedValues = [
                                ...selectedValues.filter(item =>
                                    !filteredOptions.some(filtered => filtered[field.ValueExpr] === item[field.ValueExpr])
                                ),
                                ...filteredOptions
                            ];
                        }
                    } else {
                        // Select/Unselect All when no filter is applied
                        newSelectedValues = isAllSelected ? [] : field.DefaultValues;
                    }

                    setSelectedValues(newSelectedValues);
                    const newValues = newSelectedValues.map(val => val[field.ValueExpr]);
                    setRequiredeHoverValue(newSelectedValues);
                    controllerField.onChange(newSelectedValues);
                    
                    setControllFieldValue(newValues);
                }}
                label={
                    <span style={{ fontSize: '13px', padding: '0.7em' }}>
                        {searchedValue?.length > 0
                            ? isAllFilteredSelected // NOSONAR
                                ? 'Unselect filtered options'
                                : 'Select filtered options'
                            : isAllSelected // NOSONAR
                                ? 'Unselect All'
                                : 'Select All'
                        }
                    </span>
                }
                control={
                    <Checkbox
                        size='small'
                        id="select-all-checkbox"
                        checked={selectedValues.length > 0 && isAllFilteredSelected}  // Use isAllFilteredSelected here
                    />
                }
            />
        </Box>
        <Divider />
        {children}
    </Paper>)
}

const hasValue = (value) => value !== undefined && value !== null && `${value}`.trim() !== '';
const PERCENTAGE_NUMERIC_PATTERN = /^\d*(\.\d{0,2})?$/;
const NON_PERCENTAGE_NUMERIC_PATTERN = /^\d*(\.0{0,2})?$/;
const STRICT_NUMERIC_PATTERN = /^\d+(\.\d+)?$/;

const roundToTwoDecimals = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
const isPercentageCalculation = (calculationValue) => String(calculationValue || '').toLowerCase() === 'percentage';
const getIncrementByCalculation = (calculationValue) => (isPercentageCalculation(calculationValue) ? 0.01 : 1);
const hasMoreThanTwoDecimals = (value) => {
    const rawText = `${value}`.trim();
    if (!rawText.includes('.')) {
        return false;
    }
    return rawText.split('.')[1].length > 2;
};
const normalizeLimitValueByCalculation = (value, calculationValue) => {
    if (!hasValue(value)) {
        return '';
    }

    const rawText = `${value}`.trim();
    const numericValue = Number(rawText);
    if (Number.isNaN(numericValue)) {
        return rawText;
    }

    if (isPercentageCalculation(calculationValue)) {
        return roundToTwoDecimals(numericValue).toFixed(2);
    }

    return Math.trunc(numericValue).toFixed(2);
};

const formatBudgetValueForGrid = (value) => {
    if (!hasValue(value)) {
        return '';
    }

    const rawText = `${value}`.trim();
    const numericValue = Number(rawText);

    if (Number.isNaN(numericValue)) {
        return rawText;
    }

    if (rawText.includes('.')) {
        return rawText;
    }

    return numericValue.toFixed(2);
};

const hasBudgetData = (row) =>
    hasValue(row?.budgetCalculation) || hasValue(row?.budgetLimitMinValue) || hasValue(row?.budgetLimitMaxValue);
const hasAdjustmentData = (row) =>
    hasValue(row?.adjustmentAmountCalculation) || hasValue(row?.adjustmentLimitMinValue) || hasValue(row?.adjustmentLimitMaxValue);

const resolveBudgetCalculationValue = (selectedBudgetCalculation) => {
    const calculationValue = selectedBudgetCalculation?.BudgetCalculationType || selectedBudgetCalculation?.BudgetCalculationValue || '';
    return hasValue(calculationValue) ? calculationValue : '';
};

const resolveAdjustmentCalculationValue = (selectedAdjustmentCalculation) => {
    const calculationValue = selectedAdjustmentCalculation?.AdjustmentAmountCalculation
        || selectedAdjustmentCalculation?.AdjustmentAmountCalculationValue
        || '';
    return hasValue(calculationValue) ? calculationValue : '';
};

const resolveBudgetMinLimit = (rows, rowIndex) => {
    if (rowIndex <= 0) {
        return { minLimit: 0 };
    }

    const previousRow = rows?.[rowIndex - 1];
    const previousMaxRawValue = previousRow?.budgetLimitMaxValue;
    if (!hasValue(previousMaxRawValue)) {
        return { error: `Max limit is not set for the previous step. Please modify the previous step to continue adding next steps.` };
    }

    const previousMaxValue = Number(previousMaxRawValue);
    if (Number.isNaN(previousMaxValue)) {
        return { error: `Budget Limit Max Value for Process Step ${rowIndex} should be a valid number.` };
    }

    const increment = getIncrementByCalculation(previousRow?.budgetCalculation);
    return { minLimit: roundToTwoDecimals(previousMaxValue + increment) };
};

const getBudgetMaxValidationMessage = ({ maxRawValue, minLimitValue, stepNumber, budgetCalculation, isCurrentStepValidation = false }) => {
    if (!hasValue(maxRawValue)) {
        return '';
    }

    const maxRawText = `${maxRawValue}`.trim();
    if (!STRICT_NUMERIC_PATTERN.test(maxRawText)) {
        return `Budget Limit Max Value for Process Step ${stepNumber} should be a valid number.`;
    }

    if (isPercentageCalculation(budgetCalculation)) {
        if (hasMoreThanTwoDecimals(maxRawText)) {
            return `Budget Limit Max Value for Process Step ${stepNumber} should have at most 2 decimal places.`;
        }
    } else if (!NON_PERCENTAGE_NUMERIC_PATTERN.test(maxRawText)) {
        return `Budget Limit Max Value for Process Step ${stepNumber} should be in whole number format (example: 45.00).`;
    }

    const maxValue = Number(maxRawValue);
    if (Number.isNaN(maxValue)) {
        return `Budget Limit Max Value for Process Step ${stepNumber} should be a valid number.`;
    }

    const minValue = Number(minLimitValue);
    if (Number.isNaN(minValue)) {
        return `Budget Limit Min Value for Process Step ${stepNumber} should be a valid number.`;
    }

    if (maxValue <= minValue) {
        if (isCurrentStepValidation) {
            return 'Budget max value should be greater than budget min value.';
        }
        return `For Process Step ${stepNumber}, Budget Limit Min Value is ${formatBudgetValueForGrid(minLimitValue)}. Please enter Budget Limit Max Value greater than ${formatBudgetValueForGrid(minLimitValue)}.`;
    }

    return '';
};

const validateBudgetRowsForSave = (rows) => { // NOSONAR
    const anyBudgetEnabled = rows.some((row) => row?.setBudgetApprovalLimit === true);
    if (anyBudgetEnabled) {
        const rowsMissingBudget = rows.filter((row) => row?.setBudgetApprovalLimit !== true);
        if (rowsMissingBudget.length > 0) {
            const missingSteps = rowsMissingBudget.map((row) => row.processStep).join(', ');
            return { valid: false, message: `Budget fields are missing. Add budget values for steps: ${missingSteps}.` };
        }
    }

    const budgetRows = rows.filter((row) => row?.setBudgetApprovalLimit === true);
    if (budgetRows.length === 0) {
        return { valid: true };
    }

    for (let index = 0; index < budgetRows.length; index += 1) {
        const currentRow = budgetRows[index];
        const stepNumber = currentRow?.processStep || index + 1;
        const minRaw = currentRow?.budgetLimitMinValue;

        if (!hasValue(minRaw)) {
            return { valid: false, message: `Fill min limit for step ${stepNumber}.` };
        }

        const minValue = Number(minRaw);
        if (Number.isNaN(minValue)) {
            return { valid: false, message: `Min limit for step ${stepNumber} should be a valid number.` };
        }

        if (index === 0 && minValue !== 0) {
            return { valid: false, message: 'Min limit for step 1 should be 0.' };
        }

        const maxValidationMessage = getBudgetMaxValidationMessage({
            maxRawValue: currentRow?.budgetLimitMaxValue,
            minLimitValue: minValue,
            stepNumber,
            budgetCalculation: currentRow?.budgetCalculation,
        });
        if (maxValidationMessage) {
            return { valid: false, message: maxValidationMessage };
        }

        if (index > 0) {
            const previousRow = budgetRows[index - 1];
            const previousStepNumber = previousRow?.processStep || index;
            const previousMaxRaw = previousRow?.budgetLimitMaxValue;

            if (!hasValue(previousMaxRaw)) {
                return { valid: false, message: `Please fill Budget Limit Max Value for Process Step ${previousStepNumber}.` };
            }

            const previousMaxValue = Number(previousMaxRaw);
            if (Number.isNaN(previousMaxValue)) {
                return { valid: false, message: `Max limit for step ${previousStepNumber} should be a valid number.` };
            }

            const expectedMinValue = roundToTwoDecimals(previousMaxValue + getIncrementByCalculation(previousRow?.budgetCalculation));
            if (Math.abs(minValue - expectedMinValue) > 0.000001) {
                return {
                    valid: false,
                    message: `Budget Limit Min Value for Process Step ${stepNumber} should be ${formatBudgetValueForGrid(expectedMinValue)}`,
                };
            }
        }

        if (index < budgetRows.length - 1 && !hasValue(currentRow?.budgetLimitMaxValue)) {
            return { valid: false, message: `Please fill Budget Limit Max Value for Process Step ${stepNumber}.` };
        }
    }

    return { valid: true };
};

const resolveAdjustmentMinLimit = (rows, rowIndex) => {
    const previousAdjustmentRows = (rows || []).slice(0, rowIndex).filter((row) => hasValue(row?.adjustmentAmountCalculation));
    if (previousAdjustmentRows.length === 0) {
        return { minLimit: 0 };
    }

    const previousRow = previousAdjustmentRows[previousAdjustmentRows.length - 1];
    const previousStepNumber = previousRow?.processStep || previousAdjustmentRows.length;
    const previousMaxRawValue = previousRow?.adjustmentLimitMaxValue;
    if (!hasValue(previousMaxRawValue)) {
        return { error: `Adjustment Limit Max Value is not set for Process Step ${previousStepNumber}. Please modify the previous step to continue adding next steps.` };
    }

    const previousMaxValue = Number(previousMaxRawValue);
    if (Number.isNaN(previousMaxValue)) {
        return { error: `Adjustment Limit Max Value for Process Step ${previousStepNumber} should be a valid number.` };
    }

    const increment = getIncrementByCalculation(previousRow?.adjustmentAmountCalculation);
    return { minLimit: roundToTwoDecimals(previousMaxValue + increment) };
};

const getAdjustmentMaxValidationMessage = ({ maxRawValue, minLimitValue, stepNumber, adjustmentAmountCalculation }) => {
    if (!hasValue(maxRawValue)) {
        return '';
    }

    const maxRawText = `${maxRawValue}`.trim();
    if (!STRICT_NUMERIC_PATTERN.test(maxRawText)) {
        return `Adjustment Limit Max Value for Process Step ${stepNumber} should be a valid number.`;
    }

    if (isPercentageCalculation(adjustmentAmountCalculation)) {
        if (hasMoreThanTwoDecimals(maxRawText)) {
            return `Adjustment Limit Max Value for Process Step ${stepNumber} should have at most 2 decimal places.`;
        }
    } else if (!NON_PERCENTAGE_NUMERIC_PATTERN.test(maxRawText)) {
        return `Adjustment Limit Max Value for Process Step ${stepNumber} should be in whole number format (example: 45.00).`;
    }

    const maxValue = Number(maxRawValue);
    if (Number.isNaN(maxValue)) {
        return `Adjustment Limit Max Value for Process Step ${stepNumber} should be a valid number.`;
    }

    const minValue = Number(minLimitValue);
    if (Number.isNaN(minValue)) {
        return `Adjustment Limit Min Value for Process Step ${stepNumber} should be a valid number.`;
    }

    if (maxValue <= minValue) {
        return 'Adjustment max value should be greater than adjustment min value.';
    }

    return '';
};

const validateAdjustmentRowsForSave = (rows) => { // NOSONAR
    const anyAdjustmentEnabled = rows.some((row) => row?.setAdjustmentApprovalLimit === true);
    if (anyAdjustmentEnabled) {
        const rowsMissingAdjustment = rows.filter((row) => row?.setAdjustmentApprovalLimit !== true);
        if (rowsMissingAdjustment.length > 0) {
            const missingSteps = rowsMissingAdjustment.map((row) => row.processStep).join(', ');
            return { valid: false, message: `Adjustment fields are missing. Add adjustment values for steps: ${missingSteps}.` };
        }
    }

    const adjustmentRows = rows.filter((row) => row?.setAdjustmentApprovalLimit === true);
    if (adjustmentRows.length === 0) {
        return { valid: true };
    }

    for (let index = 0; index < adjustmentRows.length; index += 1) {
        const currentRow = adjustmentRows[index];
        const stepNumber = currentRow?.processStep || index + 1;
        if (!hasValue(currentRow?.adjustmentAmountCalculation)) {
            return { valid: false, message: `Fill Adjustment Amount Calculation for step ${stepNumber}.` };
        }
        const minRaw = currentRow?.adjustmentLimitMinValue;

        if (!hasValue(minRaw)) {
            return { valid: false, message: `Fill adjustment min limit for step ${stepNumber}.` };
        }

        const minValue = Number(minRaw);
        if (Number.isNaN(minValue)) {
            return { valid: false, message: `Adjustment min limit for step ${stepNumber} should be a valid number.` };
        }

        if (index === 0 && minValue !== 0) {
            return { valid: false, message: 'Adjustment min limit for first selected step should be 0.' };
        }

        const maxValidationMessage = getAdjustmentMaxValidationMessage({
            maxRawValue: currentRow?.adjustmentLimitMaxValue,
            minLimitValue: minValue,
            stepNumber,
            adjustmentAmountCalculation: currentRow?.adjustmentAmountCalculation,
        });
        if (maxValidationMessage) {
            return { valid: false, message: maxValidationMessage };
        }

        if (index > 0) {
            const previousRow = adjustmentRows[index - 1];
            const previousStepNumber = previousRow?.processStep || index;
            const previousMaxRaw = previousRow?.adjustmentLimitMaxValue;

            if (!hasValue(previousMaxRaw)) {
                return { valid: false, message: `Please fill Adjustment Limit Max Value for Process Step ${previousStepNumber}.` };
            }

            const previousMaxValue = Number(previousMaxRaw);
            if (Number.isNaN(previousMaxValue)) {
                return { valid: false, message: `Adjustment max limit for step ${previousStepNumber} should be a valid number.` };
            }

            const expectedMinValue = roundToTwoDecimals(previousMaxValue + getIncrementByCalculation(previousRow?.adjustmentAmountCalculation));
            if (Math.abs(minValue - expectedMinValue) > 0.000001) {
                return {
                    valid: false,
                    message: `Adjustment Limit Min Value for Process Step ${stepNumber} should be ${formatBudgetValueForGrid(expectedMinValue)}`,
                };
            }
        }

        if (index < adjustmentRows.length - 1 && !hasValue(currentRow?.adjustmentLimitMaxValue)) {
            return { valid: false, message: `Please fill Adjustment Limit Max Value for Process Step ${stepNumber}.` };
        }
    }

    return { valid: true };
};

const syncNextBudgetRowMinLimit = (rows, rowIndex) => {
    if (!Array.isArray(rows) || rowIndex < 0 || rowIndex >= rows.length - 1) {
        return rows;
    }

    const currentRow = rows[rowIndex];
    const nextRow = rows[rowIndex + 1];
    const isCurrentBudgetEnabled = currentRow?.setBudgetApprovalLimit === true;
    const isNextBudgetEnabled = nextRow?.setBudgetApprovalLimit === true;

    if (!isCurrentBudgetEnabled || !isNextBudgetEnabled) {
        return rows;
    }

    const currentMaxRaw = currentRow?.budgetLimitMaxValue;
    if (!hasValue(currentMaxRaw)) {
        return rows;
    }

    const currentMaxValue = Number(currentMaxRaw);
    if (Number.isNaN(currentMaxValue)) {
        return rows;
    }

    const increment = getIncrementByCalculation(currentRow?.budgetCalculation);
    const nextMinValue = formatBudgetValueForGrid(roundToTwoDecimals(currentMaxValue + increment));
    return rows.map((row, index) =>
        (index === rowIndex + 1 ? { ...row, budgetLimitMinValue: nextMinValue } : row)
    );
};

const syncNextAdjustmentRowMinLimit = (rows, rowIndex) => {
    if (!Array.isArray(rows) || rowIndex < 0 || rowIndex >= rows.length - 1) {
        return rows;
    }

    const currentRow = rows[rowIndex];
    if (!hasValue(currentRow?.adjustmentAmountCalculation)) {
        return rows;
    }

    const currentMaxRaw = currentRow?.adjustmentLimitMaxValue;
    if (!hasValue(currentMaxRaw)) {
        return rows;
    }

    const currentMaxValue = Number(currentMaxRaw);
    if (Number.isNaN(currentMaxValue)) {
        return rows;
    }

    const nextAdjustmentRowIndex = rows.findIndex(
        (row, index) => index > rowIndex && hasValue(row?.adjustmentAmountCalculation)
    );
    if (nextAdjustmentRowIndex === -1) {
        return rows;
    }

    const increment = getIncrementByCalculation(currentRow?.adjustmentAmountCalculation);
    const nextMinValue = formatBudgetValueForGrid(roundToTwoDecimals(currentMaxValue + increment));
    return rows.map((row, index) =>
        (index === nextAdjustmentRowIndex ? { ...row, adjustmentLimitMinValue: nextMinValue } : row)
    );
};

export default function ApprovalHierarchyEdit() {
    const modulePathname = useModulePathname();
    const moduleListPath = useModuleListPath();
    const permissionsByRoute = useMenuAccessStore((state) => state.permissionsByRoute);
    const currentMenuPermissions = getMenuPermissionsForPath(permissionsByRoute, modulePathname);
    const canUpdate = currentMenuPermissions?.update === true;
    const canDelete = currentMenuPermissions?.delete === true;
    const [entityData, setEntityData] = useState([]);
    const [displayError, setDisplayError] = useState(false);
    const [getReturn, setReturn] = useState(false);
    
    
    
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);
    const [Edit, setEdit] = useState(false);
    const [cleared, setCleared] = useState(false);
    const [updatedRow, setUpdatedRow] = useState(0);
    const [openLoading, setOpenLoading] = useState(false);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState(null);
    const [currentPage] = useState(1);
    const [getRequiredeHoverValue, setRequiredeHoverValue] = useState([]);
    const [controllFieldValue, setControllFieldValue] = useState([]);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [formattedRows, setFormattedRows] = useState([]);
    const [alert, setAlert] = useState({ severity: '', message: '', show: false });
    const [searchedValue, setSearchedValue] = useState('');
    const [selectedValues, setSelectedValues] = useState([]);

    // budget changes

    const [selectedBudgetCalculation, setSelectedBudgetCalculation] = useState(null);
    const [selectedAdjustmentCalculation, setSelectedAdjustmentCalculation] = useState(null);
    const [budgetValidationError, setBudgetValidationError] = useState('');
    const [adjustmentValidationError, setAdjustmentValidationError] = useState('');
    const [showMissingMaxConfirm, setShowMissingMaxConfirm] = useState(false);
    const [pendingRowData, setPendingRowData] = useState(null);
    const [missingMaxConfirmMessage, setMissingMaxConfirmMessage] = useState(BUDGET_MISSING_MAX_CONFIRM_MSG);
    const [simplePopup, setSimplePopup] = useState({ open: false, message: '' });
    const [roleNameValues, setRoleNameValues] = useState(null); // NOSONAR

    // budget changes
    
    const { handleSubmit, control, setValue,reset, watch, unregister, clearErrors, getValues } = useForm({
        resolver: yupResolver(buildValidationSchema(entityData)),
        shouldUnregister: true
    });
    const setBudgetApprovalLimitValue = watch('SetBudgetApprovalLimit');
    const setAdjustmentApprovalLimitValue = watch('SetAdjustmentApprovalLimit');
    const budgetCalculationTypeValue = watch('BudgetCalculationType');
    const adjustmentAmountCalculationValue = watch('AdjustmentAmountCalculation');
    const isBudgetApprovalLimitEnabled = setBudgetApprovalLimitValue === true || setBudgetApprovalLimitValue === 'true';
    const isAdjustmentApprovalLimitEnabled = setAdjustmentApprovalLimitValue === true || setAdjustmentApprovalLimitValue === 'true';
    const isAdjustmentCalculationEnabled = isAdjustmentApprovalLimitEnabled && hasValue(adjustmentAmountCalculationValue);
    const budgetDependentFields = BUDGET_DEPENDENT_FIELDS;
    const adjustmentDependentFields = ADJUSTMENT_DEPENDENT_FIELDS;
    const location = useLocation();
    
    const {
        setIsListChanged,
    } = useAppStore();
    const navigate = useModuleNavigate();
    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    useEffect(() => {
        if (!isBudgetApprovalLimitEnabled) {
            setValue('BudgetLimitMinValue', '');
            return;
        }

        const currentBudgetMinValue = getValues('BudgetLimitMinValue');
        if (Edit && hasValue(currentBudgetMinValue)) {
            // In edit mode, keep the selected row's existing min value when it already exists.
            return;
        }

        const editRowIndex = formattedRows.findIndex((row) => row.id === updatedRow);
        const targetRowIndex = Edit && editRowIndex > -1 ? editRowIndex : formattedRows.length;
        const { minLimit, error: minLimitError } = resolveBudgetMinLimit(formattedRows, targetRowIndex);
        if (minLimitError) {
            setValue('BudgetLimitMinValue', '');
            return;
        }

        setValue('BudgetLimitMinValue', formatBudgetValueForGrid(minLimit));
    }, [isBudgetApprovalLimitEnabled, Edit, formattedRows, setValue, updatedRow, getValues]);

    useEffect(() => {
        if (!isAdjustmentApprovalLimitEnabled) {
            setValue('AdjustmentLimitMinValue', '');
            return;
        }

        const editRowIndex = formattedRows.findIndex((row) => row.id === updatedRow);
        const targetRowIndex = Edit && editRowIndex > -1 ? editRowIndex : formattedRows.length;
        const { minLimit, error: minLimitError } = resolveAdjustmentMinLimit(formattedRows, targetRowIndex);
        if (minLimitError) {
            setValue('AdjustmentLimitMinValue', '');
            return;
        }

        setValue('AdjustmentLimitMinValue', formatBudgetValueForGrid(minLimit));
    }, [isAdjustmentApprovalLimitEnabled, adjustmentAmountCalculationValue, Edit, formattedRows, setValue, updatedRow]);
     
    const fetchAddControls = async () => { // NOSONAR
        try {
            setOpenLoading(true);
            const res = await MasterServices.GetApprovalHierarchyDetails(location.state.data.id);
            
            setFormattedRows((prev) => {
                // Map over DisplayData to create the array of row objects
                let updatedRows = res.DisplayData.map((displayData, index) => {
                    const correspondingData = res.Data.find(data => data.ProcessStep === displayData.ProcessStep);
                    
                    const generateUserData = () => {
                        const userNames = displayData.UserName.split(",");
                        const userIds = correspondingData.ProcessApproverUserId.split(",");

                        // Map the user data into the desired format
                        const result = userIds.map((userId, index1) => ({
                            ProcessApproverUserId: parseInt(userId.trim(), 10),
                            UserName: userNames[index1].trim()
                        }));

                        return result;
                    };

                    // Get the transformed data
                    const userData = generateUserData();
                    const rawSetBudgetApprovalLimit = correspondingData?.setBudgetApprovalLimit ?? correspondingData?.SetBudgetApprovalLimit;
                    const rawSetAdjustmentApprovalLimit = correspondingData?.setAdjustmentApprovalLimit ?? correspondingData?.SetAdjustmentApprovalLimit;
                    const derivedSetBudgetApprovalLimit =
                        rawSetBudgetApprovalLimit !== undefined
                            ? (rawSetBudgetApprovalLimit === true || rawSetBudgetApprovalLimit === 'true')
                            : hasValue(correspondingData?.BudgetCalculation) || hasValue(correspondingData?.BudgetLimitMinValue) || hasValue(correspondingData?.BudgetLimitMaxValue);
                    const derivedSetAdjustmentApprovalLimit =
                        rawSetAdjustmentApprovalLimit !== undefined
                            ? (rawSetAdjustmentApprovalLimit === true || rawSetAdjustmentApprovalLimit === 'true')
                            : hasValue(correspondingData?.AdjustmentAmountCalculation) || hasValue(correspondingData?.AdjustmentLimitMinValue) || hasValue(correspondingData?.AdjustmentLimitMaxValue);
                    const normalizedBudgetMaxValue = normalizeLimitValueByCalculation(
                        correspondingData?.BudgetLimitMaxValue ?? '',
                        correspondingData?.BudgetCalculation || ''
                    );
                    const normalizedAdjustmentMaxValue = normalizeLimitValueByCalculation(
                        correspondingData?.AdjustmentLimitMaxValue ?? '',
                        correspondingData?.AdjustmentAmountCalculation || ''
                    );
                    return {
                        id: index + 1,
                        processStep: displayData.ProcessStep,
                        processName: displayData.ProcessName,
                        roleName: displayData.RoleName,
                        userNameArray: userData,
                        userName: displayData.UserName,
                        editDelete: 'Edit/Delete',
                        roleId: correspondingData ? correspondingData.ProcessApproverRoleId : null,
                        approverId: correspondingData ? correspondingData.ProcessApproverUserId : null,
                        setBudgetApprovalLimit: derivedSetBudgetApprovalLimit,
                        setAdjustmentApprovalLimit: derivedSetAdjustmentApprovalLimit,
                        // budget changes ADD:
                        budgetCalculation: correspondingData?.BudgetCalculation || '',
                        budgetLimitMinValue: formatBudgetValueForGrid(correspondingData?.BudgetLimitMinValue ?? ''),
                        budgetLimitMaxValue: formatBudgetValueForGrid(normalizedBudgetMaxValue),
                        adjustmentAmountCalculation: correspondingData?.AdjustmentAmountCalculation || '',
                        adjustmentLimitMinValue: formatBudgetValueForGrid(correspondingData?.AdjustmentLimitMinValue ?? ''),
                        adjustmentLimitMaxValue: formatBudgetValueForGrid(normalizedAdjustmentMaxValue),
                    };
                });

                // Return the new array, replacing the previous rows
                return updatedRows;
            });
            setOpenLoading(false);


            const controls = Array.isArray(res.Controls) ? res.Controls : [];
            const hierarchyDataRows = Array.isArray(res.Data) ? res.Data : [];
            setEntityData(controls);
            const budgetLimitControl = controls.find((controlData) => controlData.DisplayExpr === 'SetBudgetApprovalLimit');
            const adjustmentLimitControl = controls.find((controlData) => controlData.DisplayExpr === 'SetAdjustmentApprovalLimit');
            const hasBudgetLimitData = hierarchyDataRows.some((rowData) => {
                const rawBudgetValue = rowData?.setBudgetApprovalLimit ?? rowData?.SetBudgetApprovalLimit;
                if (rawBudgetValue !== undefined) {
                    return rawBudgetValue === true || rawBudgetValue === 'true';
                }
                return hasValue(rowData?.BudgetCalculation) || hasValue(rowData?.BudgetLimitMinValue) || hasValue(rowData?.BudgetLimitMaxValue);
            });
            const hasAdjustmentLimitData = hierarchyDataRows.some((rowData) => {
                const rawAdjustmentValue = rowData?.setAdjustmentApprovalLimit ?? rowData?.SetAdjustmentApprovalLimit;
                if (rawAdjustmentValue !== undefined) {
                    return rawAdjustmentValue === true || rawAdjustmentValue === 'true';
                }
                return hasValue(rowData?.AdjustmentAmountCalculation) || hasValue(rowData?.AdjustmentLimitMinValue) || hasValue(rowData?.AdjustmentLimitMaxValue);
            });
            if (budgetLimitControl) {
                const defaultBudgetLimitValue = budgetLimitControl.DefaultValues?.[0];
                const isDefaultBudgetLimitEnabled = hasBudgetLimitData || (defaultBudgetLimitValue === true || defaultBudgetLimitValue === 'true');
                setValue('SetBudgetApprovalLimit', isDefaultBudgetLimitEnabled);
            }
            if (adjustmentLimitControl) {
                const defaultAdjustmentLimitValue = adjustmentLimitControl.DefaultValues?.[0];
                const isDefaultAdjustmentLimitEnabled = hasAdjustmentLimitData || (defaultAdjustmentLimitValue === true || defaultAdjustmentLimitValue === 'true');
                setValue('SetAdjustmentApprovalLimit', isDefaultAdjustmentLimitEnabled);
            }
        } catch (err) {
            console.error('Error fetching add controls: ', err);
        }
    };

    





    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.columnHeader}`]: {
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '13px',
            lineHeight: 'normal',
            paddingLeft: '5px',
            whiteSpace: 'normal',
        },
        '& .MuiDataGrid-columnHeaderTitleContainer': {
            padding: '0 4px',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            whiteSpace: 'normal',
            lineHeight: '1.2',
            fontSize: '12px',
        },

        '& .MuiDataGrid-cell': {
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`, // Top border for all cells
            fontSize: '13px', // Adjust font size if needed
            padding: '4px 5px', // Adjust padding to remove vertical space
            display: 'flex', // Ensure the content is aligned top
            alignItems: 'flex-start', // Align content at the top
            whiteSpace: 'normal', // Allow text to wrap
            wordWrap: 'break-word', // Ensure long words break and wrap to the next line
            overflow: 'visible',  // Make sure overflow content is visible
            height: 'auto', // Allow the cell height to expand based on content
            '&:hover': {
                backgroundColor: 'white',
            },
        },

        // Remove top border for first row
        '& .MuiDataGrid-row:first-child .MuiDataGrid-cell': {
            borderTop: 'none',  // No top border for the first row
        },

        '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,  // Bottom border for last row
        },

        '& .MuiDataGrid-row': {
            minHeight: '45px',  // Ensure no extra space vertically for rows
            display: 'flex', // Align rows as flex containers
            alignItems: 'stretch', // Stretch row content to match height
            '&:hover': {
                backgroundColor: 'white',
            },
            padding: '0px 0px'

        },

        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },

        '& .MuiDataGrid-menuIcon': {
            display: 'none',
        },


    }));

    // Use the DataGrid component with specific rowHeight and headerHeight
    


    const clickHandler = async (data) => {
        setDisplayError(false);
        const newData = entityData.map(values => {
            if (values.LabelName === "User Name") {
                return {
                    ...values,
                    DefaultValues: ''
                };
            }
            return values;
        });
        setEntityData(() => newData);

        try {
            setOpenLoading(true);

            const res = await MasterServices.getRoleWiseUser(data.ProcessApproverRoleId);
            setReturn(res.length === 0);
            
            if (!Array.isArray(entityData)) {
                throw new Error("entityData is not an array");
            }
            const newData2 = entityData.map(values => {
                if (values.LabelName === "User Name") {
                    return {
                        ...values,
                        DefaultValues: res
                    };
                }
                return values;
            });

            setEntityData(newData2);
            setOpenLoading(false);

        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response.data.error.message);
            setErrorCode(err.response.status);
            setOpen(true);
            setOpenLoading(false);
        }
    };

    const newUpdatedForm = async (data, options = {}) => { // NOSONAR
        try {
            const { skipMissingMaxConfirm = false } = options;
            const isBudgetLimitRequested = data?.SetBudgetApprovalLimit === true || data?.SetBudgetApprovalLimit === 'true';
            const isAdjustmentLimitRequested = data?.SetAdjustmentApprovalLimit === true || data?.SetAdjustmentApprovalLimit === 'true';
            const isBudgetLimitEnabled = isBudgetLimitRequested;
            const isAdjustmentLimitEnabled = isAdjustmentLimitRequested;
            const maxRawValue = data?.BudgetLimitMaxValue;
            const adjustmentMaxRawValue = data?.AdjustmentLimitMaxValue;
            const editRowIndex = formattedRows.findIndex((row) => row.id === updatedRow);
            const isEditingExistingRow = Edit && editRowIndex > -1;
            const rowIndex = isEditingExistingRow ? editRowIndex : formattedRows.length;
            let minLimitValue = '';
            let adjustmentMinLimitValue = '';
            const submittedBudgetCalculation = resolveBudgetCalculationValue(selectedBudgetCalculation);
            const submittedAdjustmentCalculation = resolveAdjustmentCalculationValue(selectedAdjustmentCalculation)
                || data?.AdjustmentAmountCalculation
                || '';
            const normalizedBudgetMaxValue = normalizeLimitValueByCalculation(maxRawValue, submittedBudgetCalculation);
            const normalizedAdjustmentMaxValue = normalizeLimitValueByCalculation(adjustmentMaxRawValue, submittedAdjustmentCalculation);
            const isAdjustmentSelected = isAdjustmentLimitEnabled && hasValue(submittedAdjustmentCalculation);

            if (isBudgetLimitEnabled) {
                const isLastBudgetRow = rowIndex === formattedRows.length - 1 || !isEditingExistingRow;
                if (!hasValue(maxRawValue) && !isLastBudgetRow) {
                    setBudgetValidationError(`Please fill Budget Limit Max Value for Process Step ${rowIndex + 1}.`);
                    return { success: false };
                }

                const { minLimit, error: minLimitError } = resolveBudgetMinLimit(formattedRows, rowIndex);
                if (minLimitError) {
                    setBudgetValidationError('');
                    setSimplePopup({ open: true, message: minLimitError });
                    return { success: false };
                } else {
                    minLimitValue = formatBudgetValueForGrid(minLimit);
                }

                if (!hasValue(maxRawValue) && !skipMissingMaxConfirm) {
                    setBudgetValidationError('');
                    setPendingRowData(data);
                    setMissingMaxConfirmMessage(BUDGET_MISSING_MAX_CONFIRM_MSG);
                    setShowMissingMaxConfirm(true);
                    return { success: false };
                }

                const maxValidationMessage = getBudgetMaxValidationMessage({
                    maxRawValue: normalizedBudgetMaxValue,
                    minLimitValue,
                    stepNumber: rowIndex + 1,
                    budgetCalculation: submittedBudgetCalculation,
                    isCurrentStepValidation: true,
                });
                if (maxValidationMessage) {
                    setBudgetValidationError(maxValidationMessage);
                    return { success: false };
                }
            }

            setBudgetValidationError('');
            setAdjustmentValidationError('');

            if (isAdjustmentSelected) {
                const hasLaterAdjustmentRow = isEditingExistingRow && formattedRows.slice(rowIndex + 1).some((row) => hasValue(row?.adjustmentAmountCalculation));
                if (!hasValue(adjustmentMaxRawValue) && hasLaterAdjustmentRow) {
                    setAdjustmentValidationError(`Please fill Adjustment Limit Max Value for Process Step ${rowIndex + 1}.`);
                    return { success: false };
                }

                if (!hasValue(adjustmentMaxRawValue) && !skipMissingMaxConfirm) {
                    setAdjustmentValidationError('');
                    setPendingRowData(data);
                    setMissingMaxConfirmMessage(ADJUSTMENT_MISSING_MAX_CONFIRM_MSG);
                    setShowMissingMaxConfirm(true);
                    return { success: false };
                }

                const { minLimit, error: minLimitError } = resolveAdjustmentMinLimit(formattedRows, rowIndex);
                if (minLimitError) {
                    setSimplePopup({ open: true, message: minLimitError });
                    return { success: false };
                }
                adjustmentMinLimitValue = formatBudgetValueForGrid(minLimit);

                const maxValidationMessage = getAdjustmentMaxValidationMessage({
                    maxRawValue: normalizedAdjustmentMaxValue,
                    minLimitValue: adjustmentMinLimitValue,
                    stepNumber: rowIndex + 1,
                    adjustmentAmountCalculation: submittedAdjustmentCalculation,
                });
                if (maxValidationMessage) {
                    setAdjustmentValidationError(maxValidationMessage);
                    return { success: false };
                }
            }

            const newOrUpdatedRow = {
                id: rowIndex + 1,
                processStep: rowIndex + 1,
                userNameArray: data?.UserName,
                processName: data?.ProcessName || "",
                roleName: selectedDropdownValue?.RoleName || '',
                userName: data?.UserName !== undefined ? data?.UserName.map((user) => user.UserName).join(', ') : '',
                editDelete: 'Edit Delete',
                roleId: data.RoleName,
                approverId: data.UserName !== undefined ? data.UserName.map((user) => user.ProcessApproverUserId).join(', ') : '',
                setBudgetApprovalLimit: isBudgetLimitEnabled,
                setAdjustmentApprovalLimit: isAdjustmentLimitEnabled,
                budgetCalculation: isBudgetLimitEnabled ? submittedBudgetCalculation : '',
                budgetLimitMinValue: isBudgetLimitEnabled ? formatBudgetValueForGrid(minLimitValue) : '',
                budgetLimitMaxValue: isBudgetLimitEnabled ? formatBudgetValueForGrid(normalizedBudgetMaxValue) : '',
                adjustmentAmountCalculation: isAdjustmentSelected ? submittedAdjustmentCalculation : '',
                adjustmentLimitMinValue: isAdjustmentSelected ? formatBudgetValueForGrid(adjustmentMinLimitValue) : '',
                adjustmentLimitMaxValue: isAdjustmentSelected ? formatBudgetValueForGrid(normalizedAdjustmentMaxValue) : '',
            };

            let updatedRows = isEditingExistingRow
                ? [...formattedRows]
                : [...formattedRows, newOrUpdatedRow];

            if (isEditingExistingRow) {
                updatedRows[rowIndex] = newOrUpdatedRow;
            }

            updatedRows = syncNextBudgetRowMinLimit(updatedRows, rowIndex);
            updatedRows = syncNextAdjustmentRowMinLimit(updatedRows, rowIndex);

            setFormattedRows(updatedRows);
            setEdit(false);
            return { success: true, updatedRows };
        } catch (err) {
            setError(err.response?.data?.error?.message || 'An error occurred');
            setErrorCode(err.response?.status);
            setOpen(true);
            setOpenLoading(false);
            return { success: false };
        }
    };

    

    useEffect(() => {
        fetchAddControls();
    }, []);

    const postRowSubmitSuccess = (submittedData = {}, options = {}) => {
        const { updatedRows = [] } = options;
        const shouldKeepBudgetFields = submittedData?.SetBudgetApprovalLimit === true || submittedData?.SetBudgetApprovalLimit === 'true';
        const shouldKeepAdjustmentFields = submittedData?.SetAdjustmentApprovalLimit === true || submittedData?.SetAdjustmentApprovalLimit === 'true';
        const preservedBudgetCalculation = selectedBudgetCalculation;
        const preservedAdjustmentCalculation = selectedAdjustmentCalculation;
        const preservedBudgetCalculationValue = resolveBudgetCalculationValue(preservedBudgetCalculation);
        const preservedAdjustmentCalculationValue = resolveAdjustmentCalculationValue(preservedAdjustmentCalculation);
        const lastRow = updatedRows.length > 0 ? updatedRows[updatedRows.length - 1] : null;
        const lastRowMaxRaw = lastRow?.budgetLimitMaxValue;
        const lastRowMaxValue = Number(lastRowMaxRaw);
        const budgetIncrement = getIncrementByCalculation(lastRow?.budgetCalculation);
        const lastAdjustmentRow = [...updatedRows].reverse().find((row) => hasValue(row?.adjustmentAmountCalculation));
        const lastAdjustmentMaxRaw = lastAdjustmentRow?.adjustmentLimitMaxValue;
        const lastAdjustmentMaxValue = Number(lastAdjustmentMaxRaw);
        const adjustmentIncrement = getIncrementByCalculation(lastAdjustmentRow?.adjustmentAmountCalculation);
        const nextMinValue = shouldKeepBudgetFields && hasValue(lastRowMaxRaw) && !Number.isNaN(lastRowMaxValue)
            ? formatBudgetValueForGrid(roundToTwoDecimals(lastRowMaxValue + budgetIncrement))
            : '';
        const nextAdjustmentMinValue = shouldKeepAdjustmentFields && hasValue(lastAdjustmentMaxRaw) && !Number.isNaN(lastAdjustmentMaxValue)
            ? formatBudgetValueForGrid(roundToTwoDecimals(lastAdjustmentMaxValue + adjustmentIncrement))
            : '';
        const newData = entityData.map(values => {
            if (values.LabelName === "User Name") return { ...values, DefaultValues: '' };
            return values;
        });
        setEntityData(newData);
        reset();

        setSelectedBudgetCalculation(shouldKeepBudgetFields ? preservedBudgetCalculation : null);
        setSelectedAdjustmentCalculation(shouldKeepAdjustmentFields ? preservedAdjustmentCalculation : null);
        setBudgetValidationError('');
        setAdjustmentValidationError('');
        setSelectedDropdownValue(null);
        setControllFieldValue([]);
        setSelectedValues([]);
        setRequiredeHoverValue([]);
        setSearchedValue('');
        setValue('SetBudgetApprovalLimit', shouldKeepBudgetFields);
        setValue('SetAdjustmentApprovalLimit', shouldKeepAdjustmentFields);
        setValue('BudgetCalculationType', shouldKeepBudgetFields ? (preservedBudgetCalculationValue || null) : null);
        setValue('BudgetLimitMinValue', nextMinValue);
        setValue('BudgetLimitMaxValue', '');
        setValue('AdjustmentAmountCalculation', shouldKeepAdjustmentFields ? (preservedAdjustmentCalculationValue || null) : null);
        setValue('AdjustmentLimitMinValue', nextAdjustmentMinValue);
        setValue('AdjustmentLimitMaxValue', '');
    };

    const onSubmit = async (data, submitOptions = {}) => {
        if (data.ProcessApproverRoleId) {
            setOpenLoading(true);
            const newData = entityData.map(values => {
                if (values.LabelName === "User Name") return { ...values, DefaultValues: '' };
                return values;
            });
            setEntityData(newData);
            clickHandler(data);
        } else {
            if (getReturn) {
                setDisplayError(true);
                return;
            }

            const submitResult = await newUpdatedForm(data, submitOptions); //  await
            if (!submitResult?.success) return;                       //  stop if validation failed
            postRowSubmitSuccess(data, { updatedRows: submitResult.updatedRows || [] });
        }
    };

    const handleMissingMaxConfirm = async (confirm) => {
        const rowData = pendingRowData;
        setShowMissingMaxConfirm(false);
        setPendingRowData(null);

        if (!confirm || !rowData) {
            return;
        }

        const submitResult = await newUpdatedForm(rowData, { skipMissingMaxConfirm: true });
        if (!submitResult?.success) return;
        postRowSubmitSuccess(rowData, { updatedRows: submitResult.updatedRows || [] });
    };

    const handleMissingMaxPopupToggle = (openState) => {
        setShowMissingMaxConfirm(openState);
        if (!openState) {
            setPendingRowData(null);
            setMissingMaxConfirmMessage(BUDGET_MISSING_MAX_CONFIRM_MSG);
        }
    };

    const handleEdit = async (id) => { // NOSONAR
        setUpdatedRow(id);
        const rowData = formattedRows.find((row) => row.id === id);
        if (!rowData) return;
        
        try {
            setOpenLoading(true);
            const res = await MasterServices.getRoleWiseUser(rowData.roleId);

            if (!Array.isArray(entityData)) {
                throw new Error('entityData is not an array');
            }

            const rowUpdatedData = entityData.map((values) => {
                if (values.LabelName === 'User Name') {
                    return {
                        ...values,
                        DefaultValues: res,
                    };
                }
                return values;
            });

            setEntityData(rowUpdatedData);
            
            setSelectedDropdownValue({
                "ProcessApproverRoleId": rowData.roleId,
                "RoleName": rowData.roleName
            })























            // Set the form values based on the row data
            setValue('ProcessName', rowData.processName);
            setValue('RoleName', rowData.roleId);
            setValue('UserName', rowData?.userNameArray || []);

            setValue('BudgetCalculationType', rowData.budgetCalculation || null);
            setValue('BudgetLimitMinValue', rowData.budgetLimitMinValue ?? '');
            setValue('BudgetLimitMaxValue', rowData.budgetLimitMaxValue ?? '');
            setValue('AdjustmentAmountCalculation', rowData.adjustmentAmountCalculation || null);
            setValue('AdjustmentLimitMinValue', rowData.adjustmentLimitMinValue ?? '');
            setValue('AdjustmentLimitMaxValue', rowData.adjustmentLimitMaxValue ?? '');
            setValue(
                'SetBudgetApprovalLimit',
                rowData.setBudgetApprovalLimit ?? hasBudgetData(rowData)
            );
            setValue(
                'SetAdjustmentApprovalLimit',
                rowData.setAdjustmentApprovalLimit ?? hasAdjustmentData(rowData)
            );
            setSelectedBudgetCalculation(
                rowData.budgetCalculation
                    ? { BudgetCalculationValue: rowData?.budgetCalculation, BudgetCalculationType: rowData?.budgetCalculation }
                    : null
            );
            setSelectedAdjustmentCalculation(
                rowData.adjustmentAmountCalculation
                    ? {
                        AdjustmentAmountCalculationValue: rowData?.adjustmentAmountCalculation,
                        AdjustmentAmountCalculation: rowData?.adjustmentAmountCalculation
                    }
                    : null
            );

            setRequiredeHoverValue(rowData?.userNameArray);
            setSelectedValues(rowData?.userNameArray)
            const userIds = rowData?.userNameArray.map(item => item.ProcessApproverUserId);
            setControllFieldValue(userIds)
            
            setOpenLoading(false);
        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response?.data?.error?.message || 'An error occurred');
            setErrorCode(err.response?.status);
            setOpen(true);
            setOpenLoading(false);
        }

        setEdit(true);
    };

    const saveHandler = async () => { // NOSONAR
        if (formattedRows.length === 0) {
            return;
        }

        const budgetValidation = validateBudgetRowsForSave(formattedRows);
        if (!budgetValidation.valid) {
            setSimplePopup({ open: true, message: budgetValidation.message });
            return;
        }

        const adjustmentValidation = validateAdjustmentRowsForSave(formattedRows);
        if (!adjustmentValidation.valid) {
            setSimplePopup({ open: true, message: adjustmentValidation.message });
            return;
        }

        try {
            setOpenLoading(true);
            const payloadData = formattedRows.map((value) => {
                const isAdjustmentLimitEnabled = value.setAdjustmentApprovalLimit === true;
                const isAdjustmentSelected = isAdjustmentLimitEnabled && hasValue(value.adjustmentAmountCalculation);
                return {
                "Id": location.state.data.id,
                "ProcessStep": `${value.processStep}`,
                "ProcessName": value.processName || '',
                "ProcessApproverRoleId": `${value.roleId}`,
                "ProcessApproverUserId": value.approverId,
                "setBudgetApprovalLimit": value.setBudgetApprovalLimit === true,
                "setAdjustmentApprovalLimit": isAdjustmentLimitEnabled,
                // budget changes ADD:
                "BudgetCalculation": value.budgetCalculation,
                "BudgetLimitMinValue": value.budgetLimitMinValue,
                "BudgetLimitMaxValue": value.budgetLimitMaxValue,
                "AdjustmentAmountCalculation": isAdjustmentSelected ? value.adjustmentAmountCalculation : '',
                "AdjustmentLimitMinValue": isAdjustmentSelected ? value.adjustmentLimitMinValue : '',
                "AdjustmentLimitMaxValue": isAdjustmentSelected ? value.adjustmentLimitMaxValue : '',
            };
            });
            
            const res = await MasterServices.UpdateApprovalHierarchy(payloadData);
            if (res) {

                setOpenLoading(false);
                setIsListChanged(true);
                setAlert({ severity: 'success', message: res.Message || 'Operation successful.', show: true });
                setTimeout(async () => {
                    setAlert({ ...alert, show: false });
                    navigate(moduleListPath);
                }, 1500);

            } else {
                setOpenLoading(false);
                setError((prev) => res.error?.message ?? prev);
                setErrorCode((prev) => res.error?.code ?? prev)
                setOpen(true)
            }



            setOpenLoading(false);

        } catch (err) {
            setOpenLoading(false);
            console.error('Error fetching invoice list: ', err);
            setError(err.response.data.error.message || "Error occured while updating Approval Hierarchy");
            setErrorCode(err.response.status);
            setOpen(true);
        }
    }
    const deleteHandler = async () => {
        try {
        setOpenLoading(true);
        const res = await MasterServices.DeleteApprovalHierarchy(location.state.data.id);        
        if (res) {
            setOpenLoading(false);
            setIsListChanged(true);
            setAlert({ severity: 'success', message: res.Message || 'Operation successful.', show: true });
            setTimeout(async () => {
                setAlert({ ...alert, show: false });
                navigate(moduleListPath);
            }, 1500);
        } else {
            setOpenLoading(false);
            setError((prev) => res.error?.message ?? prev);
            setErrorCode((prev) => res.error?.code ?? prev)
            setOpen(true)
            }
        } catch (err) {
            console.error('Error fetching invoice list: ', err);
            setError(err.response.data.error.message);
            setErrorCode(err.response.status);
            setOpen(true);
            setOpenLoading(false);
        }
    }
    const setHandleDelete = () => {
        setDeleteConfirm(true);

    }
    const handleDelete = (id) => {
        try {
            setFormattedRows((prev) => {
                // Filter out the row with the specified id
                const updatedRows = prev.filter((row) => row.id !== id);

                // Recalculate the processStep for each remaining row
                return updatedRows.map((row, index) => ({
                    ...row,
                    processStep: index + 1, // Reassign processStep based on new index
                    id: index + 1, // Optionally update the id if it should match processStep
                }));
            });

        } catch (err) {
            console.error('Error deleting the row: ', err);
            setError('Failed to delete the row');
            setOpen(true);
        }
    };

    const handleDeleteAllRows = useCallback(() => {
        setShowDeleteConfirmation(true);
    }, []);

    const handleConfirmDeleteAll = useCallback((confirm) => {
        if (confirm) {
            setFormattedRows([]);
            setEdit(false);
            setUpdatedRow(0);
            setPendingRowData(null);
            setShowMissingMaxConfirm(false);
        }
        setShowDeleteConfirmation(false);
    }, [setFormattedRows]);

    useEffect(() => {
        if (!isBudgetApprovalLimitEnabled) {
            unregister(budgetDependentFields);
            clearErrors(budgetDependentFields);
            setSelectedBudgetCalculation(null);
            setBudgetValidationError('');
        }
    }, [isBudgetApprovalLimitEnabled, unregister, clearErrors, budgetDependentFields]);

    useEffect(() => {
        if (!isAdjustmentApprovalLimitEnabled) {
            unregister(adjustmentDependentFields);
            clearErrors(adjustmentDependentFields);
            setSelectedAdjustmentCalculation(null);
            setAdjustmentValidationError('');
            setValue('AdjustmentAmountCalculation', null);
            setValue('AdjustmentLimitMinValue', '');
            setValue('AdjustmentLimitMaxValue', '');
        }
    }, [isAdjustmentApprovalLimitEnabled, unregister, clearErrors, adjustmentDependentFields, setValue]);

    const columns = [
        { field: 'processStep', headerName: 'Process Step', flex: 0.5, minWidth: 115, cellClassName: 'processStep' },
        { field: 'processName', headerName: 'Process Name', flex: 0.9, minWidth: 150, cellClassName: 'processName' },
        { field: 'roleName', headerName: 'Role Name', flex: 0.9, minWidth: 130, cellClassName: 'roleName' },
        { field: 'userName', headerName: 'User Name', flex: 1.2, minWidth: 190, cellClassName: 'userName' },
        ...(isBudgetApprovalLimitEnabled ? [
            { field: 'budgetCalculation', headerName: 'Budget Calculation', flex: 1, minWidth: 170 },
            { field: 'budgetLimitMinValue', headerName: 'Budget Limit Min Value', flex: 0.9, minWidth: 165 },
            { field: 'budgetLimitMaxValue', headerName: 'Budget Limit Max Value', flex: 0.9, minWidth: 165 },
        ] : []),
        ...(isAdjustmentApprovalLimitEnabled ? [
            { field: 'adjustmentAmountCalculation', headerName: 'Adjustment Amount Calculation', flex: 1, minWidth: 200 },
            { field: 'adjustmentLimitMinValue', headerName: 'Adjustment Limit Min Value', flex: 0.9, minWidth: 190 },
            { field: 'adjustmentLimitMaxValue', headerName: 'Adjustment Limit Max Value', flex: 0.9, minWidth: 190 },
        ] : []),
        {
            field: 'Edit',
            headerName: 'Edit',
            flex: 0.4,
            minWidth: 80,
            align: 'left',
            renderCell: (params) => (
                <Stack direction='row'>
                    <IconButton
                        onClick={() => handleEdit(params.row.id)}
                    >
                        <Iconify icon="material-symbols:edit-outline" width="15px" height="15px" color="primary.main" />
                    </IconButton>
                </Stack>
            ),
        },
        {
            field: 'Delete',
            headerName: 'Delete',
            flex: 0.4,
            minWidth: 110,
            align: 'left',
            renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        onClick={handleDeleteAllRows} title="Delete All"
                        sx={{ display: 'flex', alignItems: 'center', marginLeft: '0px', paddingLeft: 0 }}
                    >
                        <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />
                    </IconButton>
                    <span>Delete</span>
                </div>
            ),
            renderCell: (params) => (
                <Stack direction='row'>
                    <IconButton
                        onClick={() => handleDelete(params.row.id)}
                    >
                        <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />
                    </IconButton>
                </Stack>
            ),
        },
    ];




    const handleClose = () => {
        setOpen(false);
    };
    function shiftDataToStart(rows1, startIndex1, endIndex1) {
        const selectedRows = rows1.slice(startIndex1, endIndex1);

        const beforeSelected = rows1.slice(0, startIndex1);

        const afterSelected = rows1.slice(endIndex1);
        let returnData;
        if (selectedRows.length % 3 === 0) {

            returnData = selectedRows.concat(beforeSelected, afterSelected);
        } else {

            returnData = selectedRows
        }
        return returnData;

    }
    const startIndex = (currentPage - 1) * 3;
    const endIndex = startIndex + 3;
    const updatedRows = shiftDataToStart(formattedRows, startIndex, endIndex);

    return (
        <Box sx={{ height:'100%' ,display: 'flex', flexDirection:'column',flexGrow:1,}}>
            {open && <ApprovalHierarchyPopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode} />}
            {deleteConfirm && <DeletePopup title="Delete Confirmation" msg='Do you want to delete?' confirm={deleteHandler} setDeleteConfirm={setDeleteConfirm} />}
            {showDeleteConfirmation && (
                <DeletePopup
                    setDeleteConfirm={setShowDeleteConfirmation}
                    confirm={handleConfirmDeleteAll}
                    title="Confirm Deletion"
                    msg="Are you sure you want to delete all rows?"
                />
            )}
            {showMissingMaxConfirm && (
                <DeletePopup
                    setDeleteConfirm={handleMissingMaxPopupToggle}
                    confirm={handleMissingMaxConfirm}
                    title="Warning"
                    msg={missingMaxConfirmMessage}
                    warning
                />
            )}
            {simplePopup.open && (
                <ApprovalHierarchyPopUpHandle
                    open={simplePopup.open}
                    handleClose={() => setSimplePopup({ open: false, message: '' })}
                    error={simplePopup.message}
                    errorCode={400}
                />
            )}
            <Box sx={{ minHeight:0, display: 'flex', flexDirection: 'column', flexGrow: 1,  }}>

                <HeaderCommon pageType="Edit" />

                <Box sx={{ minHeight: 0, display: 'flex', flexDirection: 'column', flexGrow: 1, }}>

                    <Box sx={{ overflow: 'auto', flexGrow: 1 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Box
                                rowGap={2}
                                columnGap={2}
                                display='grid'
                                gridTemplateColumns={{
                                    xs: '1fr',
                                    sm: '1fr 1fr',
                                    md: '1fr 1fr 1fr',
                                    lg: '1fr 1fr 1fr',
                                    xl: '1fr 1fr 1fr'
                                }}
                                sx={{ paddingTop: '0.4em' }}
                            >

                                {getOrderedControls(entityData).map((field) => { // NOSONAR
                                    if (!isBudgetApprovalLimitEnabled && budgetDependentFields.includes(field.DisplayExpr)) {
                                        return null;
                                    }

                                    if (!isAdjustmentApprovalLimitEnabled && adjustmentDependentFields.includes(field.DisplayExpr)) {
                                        return null;
                                    }

                                    return (
                                        <Box
                                            key={field.ValueExpr}
                                            sx={
                                                field.DisplayExpr === 'SetAdjustmentApprovalLimit'
                                                    ? {
                                                        gridColumn: {
                                                            xs: '1 / -1',
                                                            sm: '2 / -1',
                                                            md: '2 / -1',
                                                            lg: '2 / -1',
                                                            xl: '2 / -1',
                                                        },
                                                    }
                                                    : undefined
                                            }
                                        >
                                            <Controller
                                                name={field.DisplayExpr}
                                                control={control}
                                                render={({ field: controllerField, fieldState }) => {

                                            switch (field.DataType) {

                                                case 'Textbox': {
                                                    const isBudgetMinField = field.DisplayExpr === 'BudgetLimitMinValue';
                                                    const isAdjustmentMinField = field.DisplayExpr === 'AdjustmentLimitMinValue';
                                                    const isBudgetNumericField = field.DisplayExpr === 'BudgetLimitMinValue' || field.DisplayExpr === 'BudgetLimitMaxValue';
                                                    const isAdjustmentNumericField = field.DisplayExpr === 'AdjustmentLimitMinValue' || field.DisplayExpr === 'AdjustmentLimitMaxValue';
                                                    const isMinField = isBudgetMinField || isAdjustmentMinField;
                                                    const isNumericField = isBudgetNumericField || isAdjustmentNumericField;
                                                    const isAdjustmentFieldDisabled = isAdjustmentNumericField && !isAdjustmentCalculationEnabled;
                                                    return (
                                                        <div>
                                                            <TextField
                                                                size="small"
                                                                id={field.ValueExpr}
                                                                {...controllerField}
                                                                label={<>
                                                                    {field.LabelName}
                                                                    {field.Validations && field.Validations.length > 0 && field.Validations[0].ValidationType === 'Required' && (
                                                                        <span style={{ color: 'red' }}> *</span>
                                                                    )}
                                                                </>}
                                                                value={controllerField.value || ''}
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value;
                                                                    if (isMinField || isAdjustmentFieldDisabled) {
                                                                        return;
                                                                    }

                                                                    if (isNumericField) {
                                                                        const calculationValue = isBudgetNumericField
                                                                            ? budgetCalculationTypeValue
                                                                            : adjustmentAmountCalculationValue;
                                                                        const numericPattern = isPercentageCalculation(calculationValue)
                                                                            ? PERCENTAGE_NUMERIC_PATTERN
                                                                            : NON_PERCENTAGE_NUMERIC_PATTERN;
                                                                        if (inputValue === '' || numericPattern.test(inputValue)) {
                                                                            controllerField.onChange(inputValue);
                                                                        }
                                                                        return;
                                                                    }

                                                                    controllerField.onChange(inputValue);
                                                                }}
                                                                onBlur={(e) => {
                                                                    controllerField.onBlur();
                                                                    if (!isNumericField || isMinField || isAdjustmentFieldDisabled) {
                                                                        return;
                                                                    }

                                                                    const calculationValue = isBudgetNumericField
                                                                        ? budgetCalculationTypeValue
                                                                        : adjustmentAmountCalculationValue;
                                                                    const normalizedValue = normalizeLimitValueByCalculation(e.target.value, calculationValue);
                                                                    controllerField.onChange(normalizedValue);
                                                                }}
                                                                disabled={isMinField || isAdjustmentFieldDisabled}
                                                                fullWidth
                                                                inputProps={isNumericField ? { inputMode: 'decimal', pattern: '^\\d*(\\.\\d*)?$' } : undefined}
                                                                
                                                                InputProps={{
                                                                    readOnly: isMinField || isAdjustmentFieldDisabled,
                                                                    style: {
                                                                        fontSize: '13px',  // Set text size to 13px
                                                                    },
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        fontSize: '14px',  // Adjust label text size to 13px as well
                                                                    },
                                                                }}
                                                            />
                                                            {Boolean(fieldState.error) && (
                                                                <FormHelperText error sx={{color: 'red', fontSize: '10px'}}>
                                                                    {fieldState.error?.message}
                                                                </FormHelperText>
                                                            )}
                                                        </div>
                                                    );
                                                }

                                                case 'Dropdown':
                                                    return (
                                                        <div>
                                                            <Autocomplete
                                                                options={Array.isArray(field.DefaultValues) ? field.DefaultValues : []}
                                                                size="small"
                                                                getOptionLabel={(option) => option[field.DisplayExpr] || ''}
                                                                multiple={field.multiple || false}
                                                                value={
                                                                    Array.isArray(controllerField.value)
                                                                        ? controllerField.value.map((val) =>
                                                                            (field.DefaultValues || []).find((opt) => opt[field.ValueExpr] === val)
                                                                        )
                                                                        : (field.DefaultValues || []).find((opt) => opt[field.ValueExpr] === controllerField.value) || null
                                                                }
                                                                onChange={(event, newValue, reason) => {
                                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {

                                                                        if (field.DisplayExpr === 'RoleName') {
                                                                            setRoleNameValues(newValue);
                                                                        }

                                                                        //  Only reset UserName if NOT Budget dropdown
                                                                        const isCalculationDropdown = field.DisplayExpr === 'BudgetCalculationType' || field.DisplayExpr === 'AdjustmentAmountCalculation';
                                                                        if (!isCalculationDropdown) {
                                                                            setValue('UserName', []);
                                                                            setControllFieldValue([]);
                                                                            setSelectedValues([]);
                                                                            setRequiredeHoverValue([]);
                                                                            setSearchedValue('');
                                                                        }

                                                                        if (field.DisplayExpr === "RoleName" && newValue === null) {
                                                                            const newData = entityData.map(values => {
                                                                                if (values.LabelName === "User Name") {
                                                                                    return { ...values, DefaultValues: '' };
                                                                                }
                                                                                return values;
                                                                            });
                                                                            setEntityData(newData);
                                                                        }

                                                                        //  Separate state for Budget vs Role
                                                                        if (field.DisplayExpr === 'BudgetCalculationType') {
                                                                            setSelectedBudgetCalculation(newValue);
                                                                            setBudgetValidationError('');
                                                                            const selectedBudgetCalculationValue = newValue?.BudgetCalculationType || newValue?.BudgetCalculationValue || '';
                                                                            const currentBudgetMaxValue = getValues('BudgetLimitMaxValue');
                                                                            if (hasValue(currentBudgetMaxValue)) {
                                                                                setValue(
                                                                                    'BudgetLimitMaxValue',
                                                                                    normalizeLimitValueByCalculation(currentBudgetMaxValue, selectedBudgetCalculationValue)
                                                                                );
                                                                            }
                                                                        } else if (field.DisplayExpr === 'AdjustmentAmountCalculation') {
                                                                            setSelectedAdjustmentCalculation(newValue);
                                                                            setAdjustmentValidationError('');
                                                                            if (!newValue) {
                                                                                setValue('AdjustmentLimitMaxValue', '');
                                                                            } else {
                                                                                const selectedAdjustmentCalculationValue = newValue?.AdjustmentAmountCalculation
                                                                                    || newValue?.AdjustmentAmountCalculationValue
                                                                                    || '';
                                                                                const currentAdjustmentMaxValue = getValues('AdjustmentLimitMaxValue');
                                                                                if (hasValue(currentAdjustmentMaxValue)) {
                                                                                    setValue(
                                                                                        'AdjustmentLimitMaxValue',
                                                                                        normalizeLimitValueByCalculation(currentAdjustmentMaxValue, selectedAdjustmentCalculationValue)
                                                                                    );
                                                                                }
                                                                            }
                                                                        } else {
                                                                            setSelectedDropdownValue(newValue);
                                                                        }

                                                                        if (Array.isArray(newValue)) {
                                                                            const newValues = newValue.map((val) => val[field.ValueExpr]);
                                                                            controllerField.onChange(newValues);
                                                                        } else {
                                                                            controllerField.onChange(newValue ? newValue[field.ValueExpr] : null);
                                                                            if (newValue?.ProcessApproverRoleId) {
                                                                                onSubmit(newValue);
                                                                            }
                                                                        }
                                                                    }
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label={<>
                                                                            {field.LabelName}
                                                                            {field.Validations && field.Validations.length > 0 && field.Validations[0].ValidationType === 'Required' && (
                                                                                <span style={{ color: 'red' }}> *</span>
                                                                            )}
                                                                        </>}
                                                                        fullWidth
                                                                        
                                                                        InputProps={{
                                                                            ...params.InputProps,  // Merge other input props
                                                                            style: {
                                                                                fontSize: '13px',  // Set input text size to 13px
                                                                            },
                                                                        }}
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                fontSize: '14px',  // Set label text size to 13px for consistency
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {Boolean(fieldState.error) && (
                                                                <FormHelperText error style={{ color: 'red', fontSize: '10px' }}>
                                                                    {fieldState.error?.message}
                                                                </FormHelperText>
                                                            )}
                                                        </div>
                                                    );

                                                case 'MultiselectDropdown':
                                                    return (
                                                        <div>

                                                            <Autocomplete
                                                                multiple
                                                                freeSolo
                                                                forcePopupIcon
                                                                size="small"
                                                                options={field.DefaultValues || []}
                                                                getOptionLabel={(option) => option[field.DisplayExpr] || ''}
                                                                disableCloseOnSelect
                                                                value={
                                                                    Array.isArray(controllFieldValue)
                                                                        ? (field.DefaultValues || []).filter((opt) =>
                                                                            controllFieldValue.includes(opt[field.ValueExpr])
                                                                        )
                                                                        : []
                                                                }
                                                                onChange={(event, value, reason) => {
                                                                    if (!(reason === 'removeOption' && event.type === 'keydown')) {
                                                                    const newValues = value.map((val) => val[field.ValueExpr]);
                                                                    setControllFieldValue(newValues);
                                                                    setSelectedValues(value);
                                                                    setRequiredeHoverValue(value);
                                                                    controllerField.onChange(value);
                                                                    }
                                                                }}
                                                                slots={{ paper: custom }}
                                                                slotProps={{ paper: { field, selectedValues, searchedValue, setSelectedValues, setRequiredeHoverValue, controllerField, setControllFieldValue } }}
                                                                PaperComponent={custom }

                                                                

                                                                ListboxProps={{
                                                                    style: {
                                                                        maxHeight: '224px',
                                                                        '& .MuiAutocomplete-option': {
                                                                            fontSize: '13px',
                                                                        },
                                                                    },
                                                                }}
                                                                renderOption={(props, option, { selected }) => (                                                             
                                                                     <li {...props} key={option[field?.ValueExpr]}>
                                                                        <Checkbox
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                            size="small"
                                                                        />
                                                                        {option[field?.DisplayExpr] || 'No Label'}
                                                                    </li>
                                                                )}
                                                                renderTags={(selected) => (
                                                                    <span style={{ fontSize: '13px' }}>
                                                                        {selected.length} items selected
                                                                    </span>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <Tooltip
                                                                        id="tooltip-title-id"
                                                                        title={
                                                                            <div
                                                                                style={{
                                                                                    maxHeight: '150px',
                                                                                    overflowY: controllerField.value?.length > 3 ? 'auto' : 'hidden',
                                                                                }}
                                                                            >
                                                                                <span
                                                                                    style={{
                                                                                        color: '#9e9e9e',
                                                                                        fontSize: '12px',
                                                                                        fontWeight: '300',
                                                                                    }}
                                                                                >
                                                                                    {getRequiredeHoverValue !== undefined ? getRequiredeHoverValue.map(item => item[field.DisplayExpr]).join(', ') : 'No items selected'}
                                                                                </span>
                                                                            </div>
                                                                        }
                                                                        arrow
                                                                        placement="top"
                                                                        PopperProps={{
                                                                            sx: {
                                                                                '& .MuiTooltip-tooltip': {
                                                                                    backgroundColor: 'white',
                                                                                    color: 'black',
                                                                                    border: '1px solid #ccc',
                                                                                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                                                },
                                                                                '& .MuiTooltip-arrow': {
                                                                                    color: '#f9f9f9',
                                                                                },
                                                                                display: controllerField.value?.length === 0 || controllerField.value === undefined || controllerField.value === null ? 'none' : '',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            {...params}
                                                                            size="small"
                                                                            fullWidth
                                                                            sx={{
                                                                                '& .MuiInputBase-input': {
                                                                                    fontSize: '13px',
                                                                                },
                                                                                '& .MuiFormLabel-root': {
                                                                                    fontSize: '14px',
                                                                                },
                                                                            }}
                                                                            onChange={e => setSearchedValue(e.target.value)}
                                                                            label={<>
                                                                                {field.LabelName}
                                                                                {field.Validations && field.Validations.length > 0 && field.Validations[0].ValidationType === 'Required' && (
                                                                                    <span style={{ color: 'red' }}> *</span>
                                                                                )}
                                                                            </>}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                endAdornment: (
                                                                                    <>
                                                                                        {params.InputProps.endAdornment}
                                                                                        {controllerField?.value?.length > 0 && (
                                                                                            <IconButton
                                                                                                onClick={() => {
                                                                                                    controllerField.onChange([]); // Clear the selected values
                                                                                                    setControllFieldValue([])
                                                                                                    setSelectedValues([])
                                                                                                }}
                                                                                                size="small"
                                                                                                style={{ padding: 0 }}
                                                                                            >
                                                                                                <CloseIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        )}
                                                                                    </>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                                disableClearable
                                                                fullWidth
                                                            />


                                                            {displayError && (
                                                                <div style={{ marginTop: '10px', marginLeft: '3px', color: 'red', fontSize: '10px' }}>
                                                                    Admin role does not have any users
                                                                </div>
                                                            )}
                                                        </div>
                                                    );

                                                case 'CheckBox': {
                                                    const checkboxDefaultValue = field.DefaultValues?.[0];
                                                    const checkboxValue = (controllerField.value === undefined
                                                        ? (checkboxDefaultValue === true || checkboxDefaultValue === 'true')
                                                        : (controllerField.value === true || controllerField.value === 'true'));
                                                    return (
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={checkboxValue}
                                                                    onChange={(event) => {
                                                                        const isChecked = event.target.checked;
                                                                        controllerField.onChange(isChecked);
                                                                        if (!isChecked) {
                                                                            if (field.DisplayExpr === 'SetBudgetApprovalLimit') {
                                                                                unregister(budgetDependentFields);
                                                                                clearErrors(budgetDependentFields);
                                                                                setSelectedBudgetCalculation(null);
                                                                                setBudgetValidationError('');
                                                                            }

                                                                            if (field.DisplayExpr === 'SetAdjustmentApprovalLimit') {
                                                                                unregister(adjustmentDependentFields);
                                                                                clearErrors(adjustmentDependentFields);
                                                                                setSelectedAdjustmentCalculation(null);
                                                                                setAdjustmentValidationError('');
                                                                                setValue('AdjustmentAmountCalculation', null);
                                                                                setValue('AdjustmentLimitMinValue', '');
                                                                                setValue('AdjustmentLimitMaxValue', '');
                                                                            }
                                                                        }
                                                                    }}
                                                                    size="small"
                                                                    sx={{ padding: '6px' }}
                                                                />
                                                            }
                                                            label={field.LabelName}
                                                            sx={{ marginTop: '8px', marginLeft: 0, paddingLeft: '4px' }}
                                                        />
                                                    );
                                                }

                                                default:
                                                    return null;
                                            }
                                                }}
                                            />
                                        </Box>
                                    )
                                })}

                            </Box>
                            
                            <div style={{ display: 'flex', gap: '20px', margin: '10px 0', justifyContent: "right" }}>
                                {budgetValidationError && (
                                    <FormHelperText sx={{ color: 'red', fontSize: '11px', mt: 1 }}>
                                        {budgetValidationError}
                                    </FormHelperText>
                                )}
                                {adjustmentValidationError && (
                                    <FormHelperText sx={{ color: 'red', fontSize: '11px', mt: 1 }}>
                                        {adjustmentValidationError}
                                    </FormHelperText>
                                )}
                                <Tooltip title="Add" arrow>
                                    <Button type='submit'

                                        variant='contained'
                                        sx={{
                                            height: '30px',
                                            width: '31px',
                                            bgcolor: '#1badd1',
                                            borderRadius: '4px',
                                            minWidth: 'auto',
                                            fontSize: '25px',
                                            '&:hover': {
                                                bgcolor: '#1badd1',
                                            },
                                        }}

                                    >
                                        +
                                    </Button>
                                </Tooltip>

                            </div>
                        </form>

                        {openLoading && < LoadingProgressBar />}
                        <Divider />
                        <Box sx={{ boxSizing: 'border-box', height: '250px', overflowX: 'auto', }}>
                            <StripedDataGrid  localeText={{ noRowsLabel: '' }}
                                rows={updatedRows}
                                columns={columns}
                                getRowHeight={() => "auto"}
                                headerHeight={56}
                                disableSelectionOnClick
                                getRowId={(row) => row.id}                                
                                hideFooter
                                sx={{
                                    height: '100%',
                                    '& .css-1vjh543-MuiDataGrid-footerContainer': {
                                        minHeight: 0
                                    },
                                    '& .css-1t5atbe-MuiDataGrid-root .MuiDataGrid-row': {
                                        paddingBottom: '0px',
                                        height: 'fit-content', // Adjust row height based on content
                                    },
                                    '& .css-1t5atbe-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell': {
                                        whiteSpace: 'pre-wrap', // Proper white-space handling for wrapping
                                        lineHeight: 1,
                                        wordWrap: 'break-word',
                                    }
                                }}
                            />
                        </Box>
                    </Box>

                    <Box sx={{py:0.5} }>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            spacing={1}
                        >
                            {canUpdate && <Tooltip title="Save" sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', height: '30px', width: '31px', padding: '4px' }}>
                                <IconButton type="save" onClick={saveHandler}>
                                    <Iconify icon="bx:save" />
                                </IconButton>
                            </Tooltip>}

                            {canDelete && <Tooltip title="Delete" sx={{ bgcolor: '#ed5565', color: '#fff', borderRadius: '4px', height: '30px', width: '31px', padding: '4px' }}>
                                <IconButton onClick={setHandleDelete}>
                                    <Iconify icon="fluent:delete-32-regular" />
                                </IconButton>
                            </Tooltip>}
                        </Stack>
                    </Box>



                    {alert.show && (
                        <Stack sx={{ width: '30%', height: '2em', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                            <Alert
                                severity={alert.severity}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => setAlert({ ...alert, show: false })}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                            >
                                {alert.message}
                            </Alert>
                        </Stack>
                    )}
                </Box>

            </Box>
        </Box>
    );
}

 
